import { musicApi } from './api/musicApi';

export const musicService = {
  /**
   * 스페이스 음원 정보 조회
   */
  async fetchPlayingMusicInfo(spaceId) {
    const { data } = await musicApi.getCurrentPlayingMusic(spaceId);

    if (data.resultCd !== '0000') {
      throw new Error('음원 정보 조회 실패');
    }

    return data.result || null;
  },
  /**
   * 개별 스페이스에 현재 재생 음원 정보 추가
   */
  async enrichSpaceWithMusic(space) {
    try {
      const music = await this.fetchPlayingMusicInfo(space.spaceId);

      if (!music) return space;

      return {
        ...space,
        artistName: music.artist || '',
        musicName: music.musicNm || '',
        albumImage: music.albumImg || '',
      };
    } catch (error) {
      console.error(`[${space.spaceId}] 음원 정보 조회 실패`, error);
      return space;
    }
  },
  /**
   * 스페이스 목록에 현재 재생 음원 정보 추가
   * @param {Array} spaces
   * @returns {Promise<Array>}
   */
  async enrichSpacesWithMusic(spaces) {
    return Promise.all(
      spaces.map(space => {
        // 유료 스페이스가 아니면 조회하지 않음
        if (space.spacePayAt !== 'Y') {
          return space;
        }

        return this.enrichSpaceWithMusic(space);
      })
    );
  },
};
